var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.state.system.isOffline ? 'offline-mode' : null,attrs:{"id":"app"}},[_c('div',{ref:"err",staticClass:"err"}),_c('router-view',[_c('dashboard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }